import { UserWorkgroup } from "../../../../users/userTypes"

export type TenantUserFormValues = Readonly<{
    username: string
    employeeId: string
    displayName: string
    email: string
    mobileNumber: string
    phoneNumber: string
    sendEmailInvitation: boolean
    ignoreUserSyncJobs: boolean
    isActive: boolean
    workgroups: ReadonlyArray<UserWorkgroup>
}>

export const defaultTenantUserFormValues: TenantUserFormValues = {
    username: "",
    employeeId: "",
    displayName: "",
    email: "",
    mobileNumber: "",
    phoneNumber: "",
    sendEmailInvitation: true,
    ignoreUserSyncJobs: false,
    isActive: true,
    workgroups: [],
}
